exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.v-toolbar__items .v-btn[data-v-408ee11c] {\n    color: white;\n}\n.v-toolbar__items .isActive[data-v-408ee11c] {\n    color: black;\n    background-color: #fafafa;\n}\n", "", {"version":3,"sources":["/./ClientApp/src/portalhome/docketing/index.vue.html?c7dbaa96"],"names":[],"mappings":";AAQA;IACA,aAAA;CACA;AAEA;IACA,aAAA;IACA,0BAAA;CACA","file":"index.vue.html","sourcesContent":["<template>\r\n    <div>\r\n        <router-view></router-view>\r\n    </div>\r\n</template>\r\n\r\n<style scoped>\r\n\r\n    .v-toolbar__items .v-btn {\r\n        color: white;\r\n    }\r\n\r\n    .v-toolbar__items .isActive {\r\n        color: black;\r\n        background-color: #fafafa;\r\n    }\r\n</style>"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-compiler?{"id":"data-v-408ee11c","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./ClientApp/src/portalhome/docketing/index.vue.html
// module id = 118
// module chunks = 0